// removed by extract-text-webpack-plugin
module.exports = {"nodePage":"_28c1kXjoXz3y-6Jy"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Nodes/NodePage.pcss
// module id = 485
// module chunks = 1